import type { FunctionComponent } from 'react';

import { defineMessages, FormattedMessage } from 'react-intl';
import SectionMessage from '@atlaskit/section-message';

const messages = defineMessages({
  warningFirstLine: {
    id: 'applinks.warning',
    defaultMessage:
      'By allowing this, you can use {appName} without storing your {appName} password in {appName}.',
    description:
      'Warning for applinks that ensures the user knows what accepting this consent will do',
  },
});

const Warning: FunctionComponent<{ appName: string }> = ({ appName }) => (
  <SectionMessage appearance="warning">
    <p></p>
    <FormattedMessage
      {...messages.warningFirstLine}
      values={{
        appName: <strong>{appName}</strong>,
      }}
    />
  </SectionMessage>
);

export default Warning;
